/* Eufra – video's pas laden en afspelen als ze in beeld komen (uit het Claude Design-project) */
(function () {
  function vis(v) { var r = v.getBoundingClientRect(); return r.bottom > -100 && r.top < (window.innerHeight || 800) + 100 && r.width > 0; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; if (v.paused && !v.hasAttribute('data-lazy-hold')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '150px 0px', threshold: 0.01 });
  var seen = new WeakSet();
  function scan() { document.querySelectorAll('video[data-lazy]').forEach(function (v) { if (!seen.has(v)) { seen.add(v); v.muted = true; v.loop = true; io.observe(v); } }); }
  window.eufraVideoVisible = vis;
  function start() { scan(); new MutationObserver(scan).observe(document.body, { childList: true, subtree: true }); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
